import { useSessionTransfer } from './useSessionTransfer';
import { useSsoSessionPickup } from './useSsoSessionPickup';
import { useSessionIdentitySync } from './useSessionIdentitySync';

export const SessionTransfer = () => {
  useSessionTransfer();
  const didFetchFreshSession = useSsoSessionPickup();
  useSessionIdentitySync(didFetchFreshSession);

  return null;
};
